import React from "react";

import {
    Stack,
    Box,
    Text,
    SimpleGrid,
    Divider,
} from "@chakra-ui/react";

import ReusableDrawer from "components/Drawers/ReusableDrawer";

import StatusBadge from "components/Badges/StatusBadge";


const ViewQuestionDrawer = ({
    isOpen,
    onClose,
    question,
}) => {

    if (!question) {
        return null;
    }


    return (

        <ReusableDrawer

            isOpen={isOpen}

            onClose={onClose}

            headerContent={
                <h2>
                    View Question
                </h2>
            }

            bodyContent={

                <Stack spacing={5}>

                    <Box>

                        <Text
                            fontSize="sm"
                            color="gray.500"
                            mb={1}
                        >
                            Question
                        </Text>

                        <Text
                            fontWeight="600"
                        >
                            {
                                question.question
                            }
                        </Text>

                    </Box>


                    <Divider />


                    <SimpleGrid
                        columns={2}
                        spacing={5}
                    >

                        <Box>

                            <Text
                                fontSize="sm"
                                color="gray.500"
                            >
                                Option A
                            </Text>

                            <Text>
                                {
                                    question.option_a
                                }
                            </Text>

                        </Box>

                        <Box>

                            <Text
                                fontSize="sm"
                                color="gray.500"
                            >
                                Option B
                            </Text>

                            <Text>
                                {
                                    question.option_b
                                }
                            </Text>

                        </Box>

                        <Box>

                            <Text
                                fontSize="sm"
                                color="gray.500"
                            >
                                Option C
                            </Text>

                            <Text>
                                {
                                    question.option_c
                                }
                            </Text>

                        </Box>

                        <Box>

                            <Text
                                fontSize="sm"
                                color="gray.500"
                            >
                                Option D
                            </Text>

                            <Text>
                                {
                                    question.option_d
                                }
                            </Text>

                        </Box>

                    </SimpleGrid>


                    <Divider />


                    <Box>

                        <Text
                            fontSize="sm"
                            color="gray.500"
                            mb={2}
                        >
                            Correct Answer
                        </Text>

                        <StatusBadge
                            label={
                                question.correct_answer ||
                                "N/A"
                            }
                            variant="success"
                        />

                    </Box>


                    <SimpleGrid
                        columns={2}
                        spacing={5}
                    >

                        <Box>

                            <Text
                                fontSize="sm"
                                color="gray.500"
                            >
                                Display Order
                            </Text>

                            <Text fontWeight="600">
                                {
                                    question.display_order
                                }
                            </Text>

                        </Box>


                        <Box>

                            <Text
                                fontSize="sm"
                                color="gray.500"
                                mb={2}
                            >
                                Status
                            </Text>

                            <StatusBadge
                                label={
                                    question.active
                                        ? "Active"
                                        : "Inactive"
                                }
                                variant={
                                    question.active
                                        ? "success"
                                        : "gray"
                                }
                            />

                        </Box>

                    </SimpleGrid>

                </Stack>
            }
        />
    );
};


export default ViewQuestionDrawer;